import useMediaQuery from '@material-ui/core/useMediaQuery'
import React, { RefObject, useEffect } from 'react'
import styled from 'styled-components'

import { usePageUrl } from '../../../../lib/pages'
import * as Styled from './styled'

import grayCloseSearchIcon from '../../../../img/closeSearch.svg'
import searchInputIcon from '../../../../img/searchInput.svg'
import whiteCloseSearchIcon from '../../../../img/whiteCloseSearch.svg'

interface SearchInputProps {
  inputRef: RefObject<HTMLInputElement>
  closeSearch: () => void
  openSearch?: () => void
  inputValue: string
  setInputValue: React.Dispatch<React.SetStateAction<string>>
  isActive: boolean
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>
}

const SearchInput: React.VFC<SearchInputProps> = ({
  inputRef,
  inputValue,
  setInputValue,
  closeSearch,
  openSearch,
  isActive,
  setIsActive,
}) => {
  const { navigate } = usePageUrl()
  const isMobile = useMediaQuery('(max-width: 991px)')

  const handleFocus = () => setIsActive(true)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setInputValue(event.target.value)

  const handleClear = () => {
    setInputValue('')

    if (isMobile) {
      setIsActive(false)
      closeSearch()
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Escape') {
      if (isActive) {
        handleClear()
        closeSearch()
        inputRef?.current?.blur()
      }
    }

    if (event.key === 'Enter') {
      if (inputValue) {
        closeSearch()
        inputRef?.current?.blur()
        navigate(`/search-results?keywords=${encodeURIComponent(inputValue)}`)
      }
    }
  }

  useEffect(() => {
    if (isActive && openSearch) {
      openSearch()
    }

    if (!isActive) {
      closeSearch()
    }
  }, [closeSearch, isActive, openSearch])

  if (isMobile) {
    return (
      <Styled.Wrapper>
        <Styled.Container isActive={isActive} id="search">
          <Styled.SearchIcon>
            <Styled.Icon src={searchInputIcon} />
          </Styled.SearchIcon>
          <Styled.SearchInput
            type="text"
            placeholder="Search by term or SKU"
            autoComplete="off"
            value={inputValue}
            onFocus={handleFocus}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            ref={inputRef}
          />
        </Styled.Container>
        <Styled.CloseButton onClick={handleClear} isActive={isActive}>
          <Styled.Icon src={whiteCloseSearchIcon} />
        </Styled.CloseButton>
      </Styled.Wrapper>
    )
  }

  return (
    <Styled.Container isActive={isActive} id="search">
      <Styled.SearchIcon>
        <Styled.Icon src={searchInputIcon} />
      </Styled.SearchIcon>
      <Styled.SearchInput
        type="text"
        placeholder="Search by term or SKU"
        autoComplete="off"
        value={inputValue}
        onFocus={handleFocus}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        ref={inputRef}
      />
      {isActive && (
        <Styled.ClearIcon onClick={handleClear}>
          <Styled.Icon src={grayCloseSearchIcon} />
        </Styled.ClearIcon>
      )}
    </Styled.Container>
  )
}

const StyledSearchInput = styled(SearchInput)``
export default StyledSearchInput
